import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledInput } from './checkbox.styled';

interface OwnProps {
    onChange: (value: boolean) => void;
}

type Props = OwnProps & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'>;

export const Checkbox: FunctionComponent<Props> = (props) => {
    const { id, children, className, onChange, ...rest } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <StyledContainer htmlFor={id} className={className}>
            <StyledInput id={id} type="checkbox" onChange={handleChange} {...rest} />
            {children}
        </StyledContainer>
    );
};
